<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M13.47 4.12a1 1 0 00-1 0L6.7 8H3a1 1 0 00-1 1v6a1 1 0 001 1h3.7l5.75 3.83A1 1 0 0014 19V5a1 1 0 00-.53-.88zM4 10h2v4H4zm8 7.13l-4-2.67V9.54l4-2.67zM17.39 8.37A1 1 0 0016 8.1a1 1 0 00-.27 1.38A4.53 4.53 0 0116.5 12a4.44 4.44 0 01-.79 2.54 1 1 0 00.29 1.39 1 1 0 001.39-.25 6.5 6.5 0 000-7.31z"/><path d="M19.79 5.74A1 1 0 1018.24 7a8 8 0 010 10 1 1 0 00.76 1.61 1 1 0 00.79-.37A10.1 10.1 0 0022 12a10 10 0 00-2.21-6.26z"/></svg>